import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IOption } from "Dashboard/domain/IOption";
import { stockService } from "../../../services/stock.service";

const DriverSelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [valueLocal, setValueLocal] = useState<IOption | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const drivers = await stockService.getDrivers();
      const op = drivers.map((driver) => {
        return {
          label: driver.name,
          value: driver.driverId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const getValue = () => {
    if (value) {
      return value;
    }
    return valueLocal;
  };

  const setValueFunction = (option: IOption | undefined) => {
    if (setValue) {
      setValue(option);
    }
    setValueLocal(option);
  };

  const handleChange = (newValue: any, actionMeta: any) => {
    setValueFunction(newValue);
    props.onChange && props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (name: string): Promise<IOption> => {
    try {
      const driver = await stockService.createDriver(name);
      return {
        label: driver.name,
        value: driver.driverId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      placeholder={""}
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      options={options}
      value={getValue()}
      {...{ error: props.error }}
    />
  );
});

export default DriverSelectCreate;
